// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/avenir);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-header {
  padding: 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  position: relative;
  z-index: 10;
}

.concierge-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: linear-gradient(135deg, #007AFF 0%, #0055FF 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 122, 255, 0.2);
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.concierge-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.concierge-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1a2a3a;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.online-status {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.875rem;
  color: #65737e;
}
.online-status::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10B981;
  display: block;
  animation: blinkGreenDot 1s infinite alternate;
}
.online-status.offline::before {
  background: #9CA3AF;
  animation: none;
}

@keyframes blinkGreenDot {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
.close-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.05);
  color: #1a2a3a;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.close-button:hover {
  background: rgba(0, 0, 0, 0.1);
  transform: scale(1.05);
}
.close-button svg {
  width: 16px;
  height: 16px;
}

@media (max-width: 768px) {
  .chat-header {
    padding: 0.75rem;
  }
  .avatar {
    width: 36px;
    height: 36px;
  }
  .concierge-name {
    font-size: 0.9375rem;
  }
  .online-status {
    font-size: 0.8125rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/chat-header/chat-header.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,6DAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;AAAJ;AAEI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAAR;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AADJ;;AAIA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AADJ;AAGI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,8CAAA;AADR;AAII;EACI,mBAAA;EACA,eAAA;AAFR;;AAMA;EACI;IACI,UAAA;EAHN;EAKE;IACI,YAAA;EAHN;EAKE;IACI,UAAA;EAHN;AACF;AAMA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAJJ;AAMI;EACI,8BAAA;EACA,sBAAA;AAJR;AAOI;EACI,WAAA;EACA,YAAA;AALR;;AASA;EACI;IACI,gBAAA;EANN;EASE;IACI,WAAA;IACA,YAAA;EAPN;EAUE;IACI,oBAAA;EARN;EAWE;IACI,oBAAA;EATN;AACF","sourcesContent":["@use '../../styles/variables' as *;\n\n// ChatHeader.scss - Header styles\n.chat-header {\n    padding: 1rem;\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n    position: relative;\n    z-index: 10;\n}\n\n.concierge-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: linear-gradient(135deg, #007AFF 0%, #0055FF 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 6px rgba(0, 122, 255, 0.2);\n\n    img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n}\n\n.concierge-details {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.concierge-name {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #1a2a3a;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.online-status {\n    display: flex;\n    align-items: center;\n    gap: 0.375rem;\n    font-size: 0.875rem;\n    color: #65737e;\n\n    &::before {\n        content: '';\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        background: #10B981;\n        display: block;\n        animation: blinkGreenDot 1s infinite alternate;\n    }\n\n    &.offline::before {\n        background: #9CA3AF;\n        animation: none;\n    }\n}\n\n@keyframes blinkGreenDot {\n    0% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.3;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n.close-button {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    border: none;\n    background: rgba(0, 0, 0, 0.05);\n    color: #1a2a3a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n        background: rgba(0, 0, 0, 0.1);\n        transform: scale(1.05);\n    }\n\n    svg {\n        width: 16px;\n        height: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .chat-header {\n        padding: 0.75rem;\n    }\n\n    .avatar {\n        width: 36px;\n        height: 36px;\n    }\n\n    .concierge-name {\n        font-size: 0.9375rem;\n    }\n\n    .online-status {\n        font-size: 0.8125rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
